import React from 'react'
import DescriptionSection from 'src/NetworkViews/layouts/home/DescriptionSection'
import TicketSection from 'src/NetworkViews/layouts/home/TicketSection'

import { truncateString } from '@common/functions/truncateString'
import BackButton from '@components/BackButton'
import { MainContainer } from '@components/MainContainer/styles'
import useMain from '@hooks/useMain'
import useNetwork from '@hooks/useNetwork'
import useNetworkWallet from '@hooks/useNetworkWallet'
import { __MAX_ELEMENTS__ } from '@types'

import { HomePageHeader, HomePageMain } from './styles'

const HomePage: React.FC = () => {
    const {
        state: {
            mainInit: { network, paymentMethods },
            hasMoreThanOneEndpoint,
        },
        operations: { reset: resetUseMain, setCurrentStep, validateWallets, setMainInitPaymentMethods },
    } = useMain()
    const {
        state: { noRenderAgain, contractAddress, currentContractAddress },
        operations: { reset: resetUseNetwork, takeContractName, tokenCount },
    } = useNetwork()
    const {
        operations: { reset: resetUseNetworkWallet, setTruncatedContractAddress },
    } = useNetworkWallet()

    React.useEffect(() => {
        if (noRenderAgain.current) {
            setCurrentStep('home')
            tokenCount()
            takeContractName()
            noRenderAgain.current = false
        }
    }, [])

    React.useEffect(() => {
        if (contractAddress) {
            setTruncatedContractAddress(truncateString(contractAddress[currentContractAddress], __MAX_ELEMENTS__))
        }
    }, [contractAddress])

    React.useMemo(() => {
        if (paymentMethods && paymentMethods.every(index => typeof index === 'string')) {
            const supportedWallets = validateWallets(paymentMethods as unknown as string[])
            setMainInitPaymentMethods(supportedWallets)
        }
    }, [paymentMethods])

    const handleGoBack = React.useCallback(() => {
        resetUseMain()
        resetUseNetwork()
        resetUseNetworkWallet()
    }, [])

    if (network) {
        return (
            <>
                <HomePageHeader as="header">
                    {hasMoreThanOneEndpoint && <BackButton handleClick={handleGoBack} message={'Back'} hasCaret />}
                </HomePageHeader>

                <HomePageMain>
                    <TicketSection />
                    <DescriptionSection />
                </HomePageMain>
            </>
        )
    }

    return (
        <MainContainer isCentered>
            <h1>ERROR</h1>
        </MainContainer>
    )
}

export default HomePage
